import { type ITrackingProps } from '../constants';
import { trackingActions } from '../tracking-actions';

/** Single dispatch seam for every betslip tracking payload built via ./build-betslip-events. */
export const trackBetslipEvent = (payload: ITrackingProps): void => {
  trackingActions.eventTracking(payload);
};
